import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Visibility from '@material-ui/icons/Visibility';

import { WithStyles } from '@material-ui/styles';
import styles from './styles';

type Props = WithStyles<typeof styles>;

const TimeLineItem: React.FC<Props> = props => {
  const { children, classes } = props;
  return (
    <ListItem disableGutters component="li" alignItems="flex-start">
      <ListAvatar>
        <Avatar component="div" className={classes.avatar}>
          <Visibility className={classes.icon} />
        </Avatar>
      </ListAvatar>
      {children}
    </ListItem>
  );
};

export default React.memo(TimeLineItem);
